import { render, staticRenderFns } from "./LoadMore.vue?vue&type=template&id=edfb3e24&"
import script from "./LoadMore.vue?vue&type=script&lang=js&"
export * from "./LoadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports